exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-icon[data-v-351f5988] {\n  position: absolute;\n  top: 15px;\n  right: 30px;\n}", ""]);

// exports
